import { render, staticRenderFns } from "./medicalLeave.vue?vue&type=template&id=1c033fb1&"
import script from "./medicalLeave.vue?vue&type=script&lang=js&"
export * from "./medicalLeave.vue?vue&type=script&lang=js&"
import style0 from "./medicalLeave.vue?vue&type=style&index=0&id=1c033fb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports